import React, {useEffect, useState } from 'react'
import "./AdNewProduct.css"
import './CheckoutProduct.css'
import dataCarts from './dataCarts'
import { useStateValue } from './StateProvider';
import axios from 'axios';
import CurrencyFormat from 'react-currency-format';
import { useHistory } from 'react-router-dom';
import { useRef } from 'react';

function AdNewProduct() {
    const [{ admnavagationoption }, dispatch] = useStateValue();
    const [title, setTitle] = useState('');
    const [price, setPrice] = useState('');
    const [weigth, setWeigth] = useState('');
    const [dimensions, setDimensions] = useState('');
    const [searching_words, setSearching_words] = useState('');
    const history = useHistory();
    const mainToyImg = useRef();
    const toyImg_2 = useRef();
    const toyImg_3 = useRef();
    const toyImg_4 = useRef();
    const [resp, setResp] = useState("");
    const [resp_2, setResp_2] = useState("");
    const [resp_3, setResp_3] = useState("");
    const [resp_4, setResp_4] = useState("");
    const [ergender, setErgender] = useState("");
    const [ertitle, setErtitle] = useState("");
    const [erprice, setErprice] = useState("");
    const [erweigth, setErweigth] = useState("");
    const [erdimensions, setErdimensions] = useState("");
    const [ersearching, setErsearching] = useState("");
    const [gender, setGender] = useState('');
    const [finalresp, setFinalResp] = useState("");
    const [finalrespgreen, setFinalRespgreen] = useState("");
    const [counter, setCounter] = useState(0);

    function useInterval(callback, delay) {

        const savedCallback = useRef();
      
        // Remember the latest callback.
        useEffect(() => {
          savedCallback.current = callback;
        }, [callback]);
      
        // Set up the interval.
        useEffect(() => {
          let id = setInterval(() => {
            savedCallback.current();
          }, delay);
          return () => clearInterval(id);
        }, [delay]);

        
    }

    useInterval(() => {
        setCounter(counter + 1);
    }, 1000);

    useEffect(() => {
        if(counter === 8){
            setFinalResp('');
            setFinalRespgreen('');
            setErdimensions('');
            setErgender('');
            setErprice('');
            setErsearching('');
            setErtitle('');
            setErweigth('');
            setResp('');
            setResp_2('');
            setResp_3('');
            setResp_4('');
        }
    }, [counter])

    useEffect(() => {
        setCounter(0);
    }, [finalrespgreen || finalresp || erweigth || ersearching || ertitle || ergender || erdimensions || erprice || resp_4 || resp_3 || resp_2 || resp])

    const onOptionChange = e => {
        setGender(e.target.value);
    }


    const hdone = () =>{

        if(title === ''){
            setErtitle('Please type the name');
        }
        if(price === ''){
            setErprice('Please type the price');
        }
        if(weigth === ''){
            setErweigth('Please type the especifications');
        }
        if(dimensions === ''){
            setErdimensions('Please type the dimensions');
        }
        if(searching_words === ''){
            setErsearching('Please type the Searching Word');
        }
        if(gender === ''){
            setErgender('Please choose gender');
        }

        if(mainToyImg.current.files.length === 0){
            setResp('Please choose the main toy image');
        }else if(toyImg_3.current.files.length !== 0 
            && toyImg_4.current.files.length !== 0 
            && toyImg_2.current.files.length !== 0 
            && mainToyImg.current.files.length !== 0
            && title !== ''
            && gender !== ''
            && price !== ''
            && weigth !== ''
            && dimensions !== ''
            && searching_words !== ''){

            const formData = new FormData();
            formData.append("picture", mainToyImg.current.files[0]);
            formData.append("name", title);
            formData.append("gender", gender);
            formData.append("price", price);
            formData.append("searching_words", searching_words);

            console.log(price)

            var xhr = new XMLHttpRequest();

            xhr.open('POST', 'https://toycityzimbabwe.com/backend/uploadCart.php', true);

            xhr.onload = function(){
                if(this.responseText !== ''){
                    var img = this.responseText;
                    console.log(img);
                    axios
                        .get('https://toycityzimbabwe.com/backend/postAddSpecs.php', {params: {title, img, weigth, dimensions}} )
                        .then(res => {
                            if(res.data === 'Upload Sucessfully'){
                                setFinalRespgreen(finalresp+'Upload Sucessfully xhr');
                                xhr_2();
                                setTitle('');
                                setPrice('');
                                setWeigth('');
                                setGender('');
                                setDimensions('');
                                setSearching_words(''); 
                            }else{
                                setFinalResp(finalrespgreen+'Error To Insert Data to Database xhr'+res.data)
                            }
                        })
                        .catch( error => {
                            console.log(error)
                        });
                    
                }else{
                    setFinalResp(finalresp+' Error To Insert Data to Database')
                }
            }

            xhr.send(formData);
        }

        if(toyImg_2.current.files.length === 0){
            setResp_2('Please choose the second toy image');
        }
        
        if(toyImg_3.current.files.length === 0){
            setResp_3('Please choose the third toy image');
        }
        
        if(toyImg_4.current.files.length === 0){
            setResp_4('Please choose the fourth toy image');
        }
        

        dispatch({
        type: 'SET_ADMNO',
        admnavagationoption: 'two'
        })
    
        
    }

    const xhr_2 = () =>{

        const formData_2 = new FormData();
            formData_2.append("picture", toyImg_2.current.files[0]);
            formData_2.append("name", title);
            formData_2.append("weigth", weigth);
            formData_2.append("dimensions", dimensions);

            console.log('_2 '+title);
            console.log('_2 '+weigth);
            console.log('_2 '+dimensions);

            var xhr_2 = new XMLHttpRequest();

            xhr_2.open('POST', 'https://toycityzimbabwe.com/backend/uploadSpecs.php', true);

            xhr_2.onload = function(){
                
                if(this.responseText === 'Upload Sucessfully'){
                    setFinalRespgreen(finalresp+' Upload Sucessfully xhr_2');
                    xhr_3();
                }else{
                    setFinalResp(finalrespgreen+' Error To Insert Data to Database xhr_2')
                }
                
            }

            xhr_2.send(formData_2);

    }

    const xhr_3 = () =>{

        const formData_3 = new FormData();
            formData_3.append("picture", toyImg_3.current.files[0]);
            formData_3.append("name", title);
            formData_3.append("weigth", weigth);
            formData_3.append("dimensions", dimensions);

            var xhr_3 = new XMLHttpRequest();

            xhr_3.open('POST', 'https://toycityzimbabwe.com/backend/uploadSpecs.php', true);

            xhr_3.onload = function(){
                
                if(this.responseText === 'Upload Sucessfully'){
                    setFinalRespgreen(finalresp+' Upload Sucessfully xhr_3');
                    xhr_4();
                }else{
                    setFinalResp(finalrespgreen+' Error To Insert Data to Database xhr_3')
                }
                
            }

            xhr_3.send(formData_3);
        
    }

    const xhr_4 = () =>{

        const formData_4 = new FormData();
            formData_4.append("picture", toyImg_4.current.files[0]);
            formData_4.append("name", title);
            formData_4.append("weigth", weigth);
            formData_4.append("dimensions", dimensions);

            var xhr_4 = new XMLHttpRequest();

            xhr_4.open('POST', 'https://toycityzimbabwe.com/backend/uploadSpecs.php', true);

            xhr_4.onload = function(){
                
                if(this.responseText === 'Upload Sucessfully'){
                    setFinalRespgreen(finalresp+' Upload Sucessfully xhr_4');
                }else{
                    setFinalResp(finalrespgreen+' Error To Insert Data to Database xhr_4')
                }
                
            }

            xhr_4.send(formData_4);
        
    }

    const hclose = () => {

        dispatch({
        type: 'SET_ADMNO',
        admnavagationoption: 'two'
        })

        history.push('/Admin14F-efghS=workApp/filesManagement-Wdf17/Admin');
    }

    return (
        <div className="adnewproduct">
            <div className="container-btn">
                <button className='x-btn' onClick={hclose}>X</button>
            </div>
            <div className='specs-cont'>
                <table>
                    <tr>
                        <th>Toy Name:</th>
                        <td>
                            <input className='toy__input' type='text' value={title} onChange={e => setTitle(e.target.value)} />
                            <div className='adnewproduct__sms'>
                                {ertitle}
                            </div>
                        </td>
                    </tr> 
                    <tr> 
                        <th>Toy Price:</th>
                        <td>
                            <input className='toy__input' type='text' value={price} onChange={e => setPrice(e.target.value)} />
                            <div className='adnewproduct__sms'>
                                {erprice}
                            </div>
                        </td>
                    </tr>
                </table>  
            </div>
            <h3>Images</h3>
            <div className='specs-cont'>
                <table>
                    <tr className='adnewproduct__upload'>
                        <th>Main Image:</th>
                        <td>
                            <input type="file"  accept="image/*" ref={mainToyImg} />
                            <div className='adnewproduct__sms'>
                                {resp}
                            </div>
                        </td>
                    </tr>
                    <tr className='adnewproduct__upload'>
                        <th>Second Image:</th>
                            <td><input type="file"  accept="image/*" ref={toyImg_2} />
                            <div className='adnewproduct__sms'>
                                {resp_2}
                            </div>
                        </td>
                    </tr>
                    <tr className='adnewproduct__upload'>
                        <th>Third Image:</th>
                        <td>
                            <input type="file"  accept="image/*" ref={toyImg_3} />
                            <div className='adnewproduct__sms'>
                                {resp_3}
                            </div>
                        </td>
                    </tr>
                    <tr className='adnewproduct__upload'>
                        <th>Fourth Image:</th>
                        <td>
                            <input type="file"  accept="image/*" ref={toyImg_4} />
                            <div className='adnewproduct__sms'>
                                {resp_4}
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <h3>Specifications</h3>
            <div className='specs-cont'>
                <table>
                    <tr>
                        <th>Description:</th>
                        <td>
                            <textarea value={weigth} onChange={e => setWeigth(e.target.value)} rows="8" cols="100" />
                            <div className='adnewproduct__sms'>
                                {erweigth}
                            </div>
                        </td>
                    </tr> 
                    <tr> 
                        <th>Dimensions:</th>
                        <td>
                            <input className='toy__input' type='text' value={dimensions} onChange={e => setDimensions(e.target.value)} />
                            <div className='adnewproduct__sms'>
                                {erdimensions}
                            </div>
                        </td>
                    </tr>
                    <tr> 
                        <th>Searching Words:</th>
                        <td>
                            <input className='toy__input' type='text' value={searching_words} onChange={e => setSearching_words(e.target.value)} />
                            <div className='adnewproduct__sms'>
                                {ersearching}
                            </div>
                        </td>
                    </tr>
                </table>

                <div className='adnewproduct__radio adnewproduct__fradio'>
                    <label htmlFor="both">Both:</label>
                        <input
                            type="radio"
                            name="gender"
                            value='Both'
                            id="both"
                            checked={gender === 'Both'}
                            onChange={onOptionChange}
                        />
                </div>
                <div className='adnewproduct__radio'>
                    <label htmlFor="male">MALE:</label>
                    <input 
                        type="radio"
                        name="gender"
                        value='Male'
                        id="male"
                        checked={gender === 'Male'}
                        onChange={onOptionChange}
                    />
                </div>
                <div className='adnewproduct__radio'>
                    <label htmlFor="female">FEMALE:</label>
                    <input
                        type="radio"
                        name="gender"
                        value='Female'
                        id="female"
                        checked={gender === 'Female'}
                        onChange={onOptionChange}
                    />
                    
                </div>
                <div className='adnewproduct__sms gender__sms'>
                    {ergender}
                </div>
            </div>
            <div className="container-btn">
                <button className='c-btn' onClick={hdone}>Done</button>
            </div>
            <div className='adnewproduct__sms gender__sms'>
                {finalresp}
            </div>
            <div className='adnewproduct__sms gender__sms'>
                {finalrespgreen}
            </div>
        </div>
    )
}

export default AdNewProduct;